















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { IUpingRes } from '@/api/files/files-updown/res'
import { getIosUpingList, getIosAppChannelList, putUpAppIos, putDownAppIos } from '@/api/files/files-updown/filesUpdown'
import { EStateColor } from '@/typings/enum'
import { getIosSource, getAppStatus, getIosAppLogs } from '@/api/files/files-app/filesApp'
import { Form } from 'element-ui'
import { resetObjValue2NoneString, compareDate } from '@/utils/tool'
// 所有渠道映射表
import { getSearchCategory } from '@/api/files/files-search/filesSearch'
import { getDownReason, getDownStatus } from '@/api/common'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { setSignature } from '@/api/developer/developer-private/private'

const dataList = [
  {
    'category': '休闲',
    'seq': 1,
    'id': 3629701,
    'icon': 'http://pics.tutuapp.com/picture/app_ios/us/2020/01/13/18/mmdx4u9bjj0x.jpeg',
    'name': 'Monster Merge King',
    'ipaPath': 'xxxxxx',
    'signFilePath': 'xxxxxx',
    'groupName': '联运游戏',
    'gorupId': 1,
    'certType': '个人开发者证书',
    'certId': 1,
    'status': '签名成功',
    'statusId': 3,
    'updateDate': '2020-01-13 17:04:41',
    'upDate': '2020-01-11 17:04:41',
    'version': 'v1.1.7',
    'editor': 'Jinx'
  },
  {
    'category': '休闲',
    'seq': 2,
    'id': 3629703,
    'icon': 'http://pics.tutuapp.com/picture/app_ios/us/2020/01/13/18/mmdx4u9bjj0x.jpeg',
    'name': 'Monster Merge King',
    'ipaPath': 'xxxxxx',
    'signFilePath': 'xxxxxx',
    'groupName': '联运游戏',
    'gorupId': 1,
    'certType': '企业开发者证书',
    'certId': 2,
    'status': '签名成功',
    'statusId': 3,
    'updateDate': '2020-01-13 17:04:41',
    'upDate': '2020-01-11 17:04:41',
    'version': 'v1.1.7',
    'editor': 'Jinx'
  },
  {
    'category': '休闲',
    'seq': 3,
    'id': 3629703,
    'icon': 'http://pics.tutuapp.com/picture/app_ios/us/2020/01/13/18/mmdx4u9bjj0x.jpeg',
    'name': 'Monster Merge King',
    'ipaPath': 'xxxxxx',
    'signFilePath': 'xxxxxx',
    'groupName': '联运游戏',
    'gorupId': 1,
    'certType': '个人开发者证书',
    'certId': 1,
    'status': '签名成功',
    'statusId': 3,
    'updateDate': '2020-01-13 17:04:41',
    'upDate': '2020-01-11 17:04:41',
    'version': 'v1.1.7',
    'editor': 'Jinx'
  }
]

const signOptions = [
  {
    id: 1,
    name: '等待上传文件'
  },
  {
    id: 2,
    name: '等待签名'
  },
  {
    id: 3,
    name: '签名成功'
  },
  {
    id: 4,
    name: '签名失败'
  }
]

@Component({
  name: 'FilesUpdownIosSignature'
})
export default class extends mixins(DateOption) {
  // data
  private params: any = {
    id: '',
    name: '',
    appleId: '',
    appGroupId: '',
    certId: '',
    status: '',
    upDateStart: '',
    upDateEnd: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private upParams = {
    id: '',
    signType: '',
    seq: '',
    groupId: ''
  }
  // add
  appGroupList: ISelectItem[] = [
    {
      id: 1,
      name: '资源'
    },
    {
      id: 2,
      name: '重点资源'
    },
    {
      id: 3,
      name: '联运游戏'
    }
  ]
  certList: ISelectItem[] = [
    {
      id: 1,
      name: '企业开发者证书'
    },
    {
      id: 2,
      name: '个人开发者证书'
    }
  ]

  private upFormVisible: boolean = false
  private tableData: any[] = []
  private selectedData: any[] = []
  private totalCount: number = 0
  private dateArray: string[] = ['', '']
  private upDateArray: string[] = ['', '']
  private stateColor = EStateColor
  private options: Array<ISelectItem> = []
  routeQuery: IQuery = { id: 0, platform: 'ios' }
  private rules: any = {
    id: [{ required: true, message: '请输入ID', trigger: 'blur' }],
    groupId: [{ required: true, message: '选择分组类型', trigger: 'change' }],
    seq: [
      {
        required: true,
        message: '请输入排序',
        trigger: 'blur'
      }
    ]
  }
  tableLoading = false
  openWindow: any
  tableHeight: number = 500

  // lifecycle
  created() {
    this.getTableData()
    this.getAppStatus()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  getTableData() {
    this.tableLoading = true
    // let res = await getIosUpingList(this.params)
    // this.tableData = res.data.dataList
    this.tableData = []
    this.tableLoading = false
    // this.totalCount = res.data.pageInfo.totalCount
  }
  getAppStatus() {
    // let res = await getAppStatus({
    //   ids: '1,2,3,4'
    // })
    // this.options = res.data
    this.options = signOptions
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  handleInput(val: string, attr: string) {
    this.params[attr] = val.replace(/[^0-9]/g, '')
  }
  async putUpAppIos() {
    // let res: any = await putUpAppIos({
    //   ids: this.upParams.id,
    //   channel: this.upParams.channel.join(','),
    //   startDate: this.upParams.startDate,
    //   endDate: this.upParams.endDate
    // })
    // if (res.status.code === 0) {
    //   this['$message'].success('提交成功!')
    //   this.cancelUpForm()
    // } else {
    //   this['$message'].error('提交失败!')
    // }
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleUpDateChange(date: string[]) {
    this.params.upDateStart = date && date[0]
    this.params.upDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.upDateArray = ['', '']
    this.params.page = 1
  }
  handleSelectionChange(list: IUpingRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSetAll() {
    this.upFormVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.upParams.id = t.join(',')
  }
  handleRepeatAll() {
    // 校验是否需要重签
    alert('no apis to use')
  }
  goToDetail(item: any) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  goToDetailSignature(item: any) {
    const { certId } = item
    this.openWindow({
      name: certId === 1 ? 'DeveloperPrivateSignature' : 'DeveloperCompanySignature'
    })
  }
  setSignature(item: any) {
    this.upFormVisible = true
    this.upParams.id = (item.id).toString()
    this.upParams.signType = item.certId
    this.upParams.seq = item.seq
    this.upParams.groupId = item.groupId
  }
  repeatSignature(item: any) {
    const { id } = item
    console.log(id)
    // let res: any = await setSignature({
    //   id: id.toString()
    // })
    // console.log(res)
    // if (res.status.code === 0) {
    //   // 更改状态
    //   this['$message'].success('签名成功')
    //   // this.$nextTick(() => {
    //   //   item.statusId = 1
    //   //   item.status = '等待签名'
    //   //   item.disabled = true
    //   //   setTimeout(() => {
    //   //     item.disabled = false
    //   //   }, 60 * 1000)
    //   // })
    // } else {
    //   this['$message'].error(res.status.message || '签名失败')
    // }
  }
  handleFormClose() {
    this.cancelUpForm()
  }
  cancelUpForm() {
    (this.$refs['upParams'] as Form).resetFields()
    this.upFormVisible = false
  }
  confirmUpForm() {
    (this.$refs['upParams'] as Form).validate(valid => {
      if (valid) {
        alert('暂无接口')
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  confirmSrc(src: string) {
    return src.replace('.com//', '.com/')
  }
  // computed
  get showMultiSelect() {
    return this.selectedData && this.selectedData !== undefined && this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData && this.selectedData !== undefined ? this.selectedData.length : ''
  }
}
